/* SelectedItemDetailsModal */
.detailList {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detailField {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detailLabel {
  font-size: 12px;
  font-weight: 500;
  color: #555;
}

.detailInput {
  padding: 6px 10px;
  border: 1px solid #e2e1e1;
  border-radius: 4px;
  background: #f5f5f5;
  color: #333;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

.qtyInput {
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

.modalButtonRow {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

/* DuplicateItemDialog / AssignmentConfirmModal */
.dialogButtonRow {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

/* MoveOrderAdd page */
.missingParamCard {
  margin: 1rem;
  padding: 1rem;
}

.pageCard {
  margin: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.pageHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pageHeaderFlex {
  flex: 1;
}

.pageHeaderTitle {
  margin: 0;
}

.contentStack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bottomSection {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.buttonRow {
  display: flex;
  flex-direction: row;
  padding: 16px;
  gap: 8px;
}

.successBanner {
  text-align: center;
  width: 100%;
  font-size: 1.5rem;
  background-color: green;
  color: white;
  margin: 0;
  padding: 8px;
}
